import { gql } from '@apollo/client';

export const GET_LIMITS_LIST = gql`
  query GetLimitsList {
    currentUserAdsLimits {
      availableFreeLimit
      availablePaidLimit
      limitUntil
      category {
        legacyResourceId
        name
        icon
        parent {
          name
          icon
        }
      }
    }
  }
`;
